<template>
  <div
    v-touch:touchhold="touchHoldHandler"
    @contextmenu.prevent="$refs.menuTransfer.open($event, 'Payload')"
  >
    <slot></slot>
    <ContextMenu ref="menuTransfer">
      <template slot-scope>
        <ContextMenuItem @click.native="getCRFile(vehicle.id)">
          Download CRVI file
          <!-- loader  -->
          <b-spinner
            v-if="isVicrFileLoading"
            small
            label="Spinning"
          ></b-spinner>
        </ContextMenuItem>
      </template>
    </ContextMenu>
  </div>
</template>

<script>
import { superAdminMixin } from "../../mixins";
import ContextMenu from "../contextMenu/ContextMenu.vue";
import ContextMenuItem from "../contextMenu/ContextMenuItem.vue";
import { GET_CR_FILE } from "./actions";
export default {
  name: "VICRContextMenu",
  props: ["vehicle", "refreshData"],
  mixins: [superAdminMixin],
  components: {
    ContextMenu,
    ContextMenuItem,
  },
  data() {
    return {
      isVicrFileLoading: false,
    };
  },

  methods: {
    touchHoldHandler($event) {
      this.$refs.menuTransfer.open($event, "Payload");
    },
    getCRFile(vehicleId) {
      // TODO: vehicleId solo proporciona el ID, no el VIN ni STOCK.
      // Formato esperado: cr_(VIN últimos 6)_(STOCK)_(DATE)
      // Necesita pasar el objeto vehicle completo o VIN/STOCK por separado
      this.isVicrFileLoading = true;
      this.$store
        .dispatch(GET_CR_FILE, { id: vehicleId })
        .then((response) => {
          if (!response.error) {
            const url = response.url;
            const link = document.createElement("a");
            /* open in blank */
            link.target = "_blank";
            link.setAttribute("href", url);

            const today = new Date();
            const dd = String(today.getDate()).padStart(2, "0");
            const mm = String(today.getMonth() + 1).padStart(2, "0");
            const yy = String(today.getFullYear()).slice(-2);
            const dateStr = `${dd}-${mm}-${yy}`;

            // TODO: Agregar VIN y STOCK cuando estén disponibles
            link.setAttribute("download", `cr_NOVIN_NOSTOCK_${dateStr}.pdf`);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch((error) => {
          this.$toast.error(error.message);
        })
        .finally(() => {
          this.isVicrFileLoading = false;
        });
    },
    formatFileName(module) {
      let fileName = "";
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yy = String(today.getFullYear()).slice(-2);
      const vinLast6 = this.vehicle.vin ? this.vehicle.vin.slice(-6) : "NOVIN";
      const stock = this.vehicle.stockNumber
        ? this.vehicle.stockNumber
        : "NOSTOCK";

      fileName = `${module}_${vinLast6}_${stock}_${dd}-${mm}-${yy}`;

      return fileName;
    },
  },
};
</script>

<style></style>
